/* R744: private Data Hub Battlegrounds reporting. Loaded only by ff-data-hub. */
(function(){
  "use strict";
  window.ffBgDataHub=function(ctx){
    var el=ctx.el,n=ctx.n,chip=ctx.chip,esc=ctx.esc,rpc=ctx.rpc,key=ctx.key;
    var whenChartReady=ctx.whenChartReady,renderSeries=ctx.renderSeries,setEmpty=ctx.setEmpty,seriesCache=ctx.seriesCache;
  /* ---------- Battlegrounds: server receipts, R744 ---------- */
  var bgDays=30,bgHours=0,bgSearch="",bgOffset=0,bgSort="last_played",bgSeq=0;
  var bgRows=[],bgSelected=null,bgHistoryOffset=0,bgHistorySeq=0,bgLastFocus=null;
  function bgN(x){return n(Number(x)||0)}
  function bgTag(){return bgHours>0?(bgHours+"h"):(bgDays>=99999?"all time":(bgDays+"d"))}
  /* 9/13/26: the UTC day, so a row agrees with the report's UTC windows and day buckets */
  function bgDate(t){if(!t)return "No play in window";var d=new Date(t);return isNaN(d.getTime())?"Unknown date":(d.getUTCMonth()+1)+"/"+d.getUTCDate()+"/"+String(d.getUTCFullYear()).slice(-2)}
  function bgClock(t){var d=new Date(t);return isNaN(d.getTime())?"just now":d.toLocaleTimeString("en-US",{hour:"numeric",minute:"2-digit"})}
  function bgCell(label,value,sub){return '<td data-label="'+label+'">'+value+(sub?'<small>'+sub+'</small>':'')+'</td>'}
  function bgPager(prefix,page){
    var total=Number(page.total)||0,offset=Number(page.offset)||0,limit=Number(page.limit)||25;
    el(prefix+"-count").textContent=total?(bgN(offset+1)+"–"+bgN(Math.min(offset+limit,total))+" of "+bgN(total)):"No matching records";
    el(prefix==="bg-player"?"bg-prev":"bg-history-prev").disabled=offset<=0;
    el(prefix==="bg-player"?"bg-next":"bg-history-next").disabled=offset+limit>=total;
  }
  function renderBgPlayers(page){
    bgRows=page.rows||[];
    el("bg-players").innerHTML=bgRows.length?'<table class="fh-bg-table"><thead><tr><th>Account</th><th>Last played</th><th>Highest round</th><th>New runs</th><th>Rounds</th><th>Hearts</th><th>Packs</th><th>Crystals</th></tr></thead><tbody>'+bgRows.map(function(p,i){
      var name=p.email||("Account "+String(p.email_hash).slice(0,8));
      return '<tr><td><button class="fh-bg-person" type="button" data-bg-player="'+i+'" aria-controls="bg-history" aria-expanded="'+(bgSelected===p.email_hash)+'">'+esc(name)+'</button></td>'
        +bgCell("Last played",esc(bgDate(p.last_played)))
        +bgCell("Highest round",Number(p.best_round)>0?bgN(p.best_round):"—")
        +bgCell("New runs",bgN(p.runs))
        +bgCell("Rounds",bgN(p.rounds_won)+" won",bgN(p.rounds_lost)+" lost")
        +bgCell("Hearts",bgN(p.hearts)+" received",bgN(p.spent)+" spent"+(p.capped?" · "+bgN(p.capped)+" capped":""))
        +bgCell("Packs",bgN(p.packs)+" awarded",bgN(p.opened)+" opened · "+bgN(p.unopened)+" unopened now")
        +bgCell("Crystals",bgN(p.crystals))+"</tr>";
    }).join("")+"</tbody></table>":'<div class="fh-empty">'+(bgSearch?"No accounts match this search.":"No players or reward recipients in this window.")+'</div>';
    bgPager("bg-player",page);
  }
  function renderBg(data,seq){
    var s=data.summary||{},series=data.series||[],rounds=(Number(s.rounds_won)||0)+(Number(s.rounds_lost)||0);
    el("bg-chips").innerHTML=
      chip("New runs · "+bgTag(),bgN(s.runs),"")+
      chip("Active players",bgN(s.players),"distinct accounts in this window")+
      chip("Rounds played",bgN(rounds),bgN(s.rounds_won)+" won · "+bgN(s.rounds_lost)+" lost")+
      chip("Highest round",bgN(s.best_round),"reached in this window");
    el("bg-rewards").innerHTML=
      chip("Hearts received",bgN(s.hearts),bgN(s.capped)+" withheld by the wallet cap")+
      chip("Hearts spent",bgN(s.spent),"recorded stop shop debits")+
      chip("Packs awarded",bgN(s.packs),bgN(s.opened)+" opened · "+bgN(s.unopened)+" unopened now")+
      chip("Crystals received",bgN(s.crystals),"credited with battle rewards");
    el("bg-reward-note").textContent="Hearts received are the amount actually credited, after the wallet cap. Entry grants do not contain a verified heart charge, so their cost is excluded from spending."
      +(s.unknown_hearts?" "+bgN(s.unknown_hearts)+" settlement receipts have no recorded heart-credit amount and are excluded from that total.":"");
    var entries=[["Daily door",s.entries_daily,"free"],["Explore reward",s.entries_explore,"free"],["Bought",s.entries_bought,"paid"],["Other / refunded",s.entries_other,""],["Used",s.entries_used,""]];
    el("bg-entries").innerHTML='<div class="fh-entrows">'+entries.map(function(e){return '<div class="fh-entrow '+e[2]+'"><div class="ek">'+e[0]+'</div><div class="ev">'+bgN(e[1])+'</div></div>'}).join("")+'</div>';
    el("bg-ladder-note").textContent=rounds?(Math.round(1000*(Number(s.rounds_won)||0)/rounds)/10+"% of settled rounds won"):"No settled rounds in this window.";
    renderBgPlayers(data.players||{});
    el("bg-status").textContent="Updated "+bgClock(data.as_of)+" · select an account to see its history.";
    whenChartReady(function(){
      if(seq!==bgSeq)return;
      var hm=bgHours>0,labels=series.map(function(x){var t=String(x.t);return hm?((bgHours>24?t.slice(5,10)+" ":"")+t.slice(11,13)+"h"):t.slice(5,10)});
      el("bg-line-label").textContent="New runs and active players, "+(hm?"by hour":"by day");
      el("bg-rounds-label").textContent="Rounds won vs lost, "+(hm?"by hour":"by day");
      renderSeries("bgLine",labels,series.map(function(x){return x.runs||0}),series.map(function(x){return x.players||0}),"New runs","Active players","#ef9a76","#8ad0e8","No recorded play in this window.");
      renderSeries("bgLadder",labels,series.map(function(x){return x.rounds_won||0}),series.map(function(x){return x.rounds_lost||0}),"Rounds won","Rounds lost","#7fd6a2","#e88a8a","No settled rounds in this window.");
    });
  }
  function bgError(e){
    var body={};try{body=JSON.parse(e&&e.message||"{}")}catch(ignore){}
    if(body.code==="PGRST202"||body.code==="42883")return "Battlegrounds reporting functions are unavailable. Complete the R744 SQL checks and installation in Supabase.";
    if(e&&(e.status===401||e.status===403)||body.message==="bad key")return "Access was not accepted. Re-enter your Data Hub key and reload.";
    return "Battlegrounds data could not be loaded. Use Refresh to retry; no totals are available for this request.";
  }
  function closeBgHistory(){
    bgSelected=null;bgHistorySeq++;bgHistoryOffset=0;el("bg-history").hidden=true;
    el("bg-players").querySelectorAll("[data-bg-player]").forEach(function(b){b.setAttribute("aria-expanded","false")});
  }
  function loadBg(k){
    var seq=++bgSeq,panel=el("bg-chips").closest(".fh-bg");
    panel.setAttribute("aria-busy","true");el("bg-status").textContent="Updating Battlegrounds…";
    el("bg-prev").disabled=true;el("bg-next").disabled=true;
    rpc("datahub_battlegrounds",{p_key:k,p_days:bgDays,p_hours:bgHours,p_search:bgSearch,p_offset:bgOffset,p_sort:bgSort})
    .then(function(data){
      if(seq!==bgSeq)return;
      if(!data||data.version!==744)throw new Error("Unexpected report version");
      panel.setAttribute("aria-busy","false");renderBg(data,seq);
      if(bgSelected)loadBgHistory();
    }).catch(function(e){
      if(seq!==bgSeq)return;
      panel.setAttribute("aria-busy","false");var msg=bgError(e);
      ["bg-chips","bg-rewards","bg-entries","bg-players"].forEach(function(id,i){el(id).innerHTML='<div class="fh-empty">'+esc(i===0?msg:"Report unavailable.")+'</div>'});
      ["bg-status","bg-reward-note","bg-ladder-note","bg-player-count"].forEach(function(id){el(id).textContent=""});
      bgRows=[];closeBgHistory();setEmpty("bgLine","Report unavailable.");setEmpty("bgLadder","Report unavailable.");
      delete seriesCache.bgLine;delete seriesCache.bgLadder;
    });
  }
  function loadBgHistory(){
    if(!bgSelected)return;
    var selected=bgSelected,seq=++bgHistorySeq;
    el("bg-history-rows").innerHTML='<div class="fh-empty">Loading history…</div>';
    el("bg-history-count").textContent="";el("bg-history-prev").disabled=true;el("bg-history-next").disabled=true;
    rpc("datahub_battlegrounds_player",{p_key:key(),p_email_hash:selected,p_days:bgDays,p_hours:bgHours,p_offset:bgHistoryOffset})
    .then(function(data){
      if(seq!==bgHistorySeq||selected!==bgSelected)return;
      if(!data||data.version!==744||data.email_hash!==selected)throw new Error("Unexpected player response");
      el("bg-history-title").textContent=(data.email||("Account "+selected.slice(0,8)))+" · "+bgTag();
      var labels={start:"New run",continue:"Continued run",settlement:"Rounds settled",shop:"Stop shop purchase",pack_awarded:"Packs awarded",pack_opened:"Pack opened",entry_granted:"Entry granted",entry_used:"Entry used"};
      el("bg-history-rows").innerHTML=(data.rows||[]).length?'<table class="fh-bg-table"><thead><tr><th>Event</th><th>Run</th><th>Recorded result</th></tr></thead><tbody>'+data.rows.map(function(r){
        var result=[];
        if(r.kind==="settlement")result.push(bgN(r.rounds_won)+" rounds won, "+bgN(r.rounds_lost)+" lost; reached round "+bgN(r.round_reached));
        if(r.hearts)result.push("+"+bgN(r.hearts)+" hearts");
        if(r.spent)result.push("−"+bgN(r.spent)+" hearts");
        if(r.capped)result.push(bgN(r.capped)+" hearts capped");
        if(r.unknown_hearts)result.push("Heart credit not recorded");
        if(r.packs)result.push("+"+bgN(r.packs)+" packs");
        if(r.opened)result.push(bgN(r.opened)+" pack opened");
        if(r.crystals)result.push("+"+bgN(r.crystals)+" crystals");
        if(r.entry_delta)result.push(bgN(Math.abs(Number(r.entry_delta)))+" entries · "+esc(r.detail));
        return '<tr>'+bgCell("Event",esc(labels[r.kind]||"Recorded event"),esc(bgDate(r.at)))
          +bgCell("Run",r.run_family?("#"+esc(r.run_family)):"—",r.run_id&&r.run_id!==r.run_family?("segment #"+esc(r.run_id)):"")
          +bgCell("Recorded result",result.join("<br>")||"Recorded by the server")+'</tr>';
      }).join("")+'</tbody></table>':'<div class="fh-empty">No recorded events for this account in this window.</div>';
      bgPager("bg-history",data);
    }).catch(function(e){
      if(seq!==bgHistorySeq||selected!==bgSelected)return;
      el("bg-history-rows").innerHTML='<div class="fh-empty">'+esc(bgError(e))+'</div>';
    });
  }
  el("bg-player-search").addEventListener("submit",function(e){e.preventDefault();bgSearch=el("bg-search").value.trim();bgOffset=0;closeBgHistory();loadBg(key())});
  el("bg-sort").addEventListener("change",function(){bgSort=this.value;bgOffset=0;loadBg(key())});
  el("bg-prev").addEventListener("click",function(){bgOffset=Math.max(0,bgOffset-25);closeBgHistory();loadBg(key())});
  el("bg-next").addEventListener("click",function(){bgOffset+=25;closeBgHistory();loadBg(key())});
  el("bg-players").addEventListener("click",function(e){
    var b=e.target.closest("[data-bg-player]"),p=b&&bgRows[Number(b.getAttribute("data-bg-player"))];
    if(!p||!/^[a-f0-9]{32}$/.test(p.email_hash)||el("bg-chips").closest(".fh-bg").getAttribute("aria-busy")==="true")return;
    closeBgHistory();bgLastFocus=b;bgSelected=p.email_hash;bgHistoryOffset=0;b.setAttribute("aria-expanded","true");
    el("bg-history").hidden=false;el("bg-history-title").textContent=(p.email||"Player")+" · "+bgTag();
    el("bg-history-title").focus();loadBgHistory();
  });
  el("bg-history-close").addEventListener("click",function(){closeBgHistory();if(bgLastFocus&&bgLastFocus.isConnected)bgLastFocus.focus()});
  el("bg-history-prev").addEventListener("click",function(){bgHistoryOffset=Math.max(0,bgHistoryOffset-25);loadBgHistory()});
  el("bg-history-next").addEventListener("click",function(){bgHistoryOffset+=25;loadBgHistory()});

    return {load:loadBg,setRange:function(days,hours,reload){
      bgDays=days;bgHours=hours;
      if(reload){bgOffset=0;closeBgHistory();loadBg(key())}
    }};
  };
  window.dispatchEvent(new Event("ff-bg-report-ready"));
})();
